import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Lincoln, NE?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Lincoln can take 2–6 months, especially during busy travel seasons. For UNL students with study-abroad deadlines, state employees on trade missions, and families with booked international travel, that timeline is simply not viable.",
  },
  {
    q: "Can UNL students get a passport fast for study abroad?",
    a: "Absolutely. UNL students are one of our most common client types in Lincoln. Study-abroad program deadlines often leave students with as little as 4–6 weeks before orientation. First-time applicants (many college students) require an in-person acceptance clerk visit. We guide UNL students through the exact location, forms, and timeline so they do not miss their program orientation in Europe, Latin America, or Asia.",
  },
  {
    q: "What if my passport expires before a state trade mission or government trip?",
    a: "This is a common situation for Lincoln's government community. Trade missions and diplomatic meetings are scheduled on fixed dates — you cannot reschedule an international delegation because your passport expired. We process expedited renewals for government travelers, with options as fast as 2–9 business days. Standard mail-in renewal through a Lincoln post office typically takes 2–6 months.",
  },
  {
    q: "Can Bryan Health or UNL faculty get an expedited passport for conferences?",
    a: "Yes. Medical and academic conferences have fixed presentation dates. A neuroscience conference in Geneva or an education symposium in Tokyo does not reschedule because your passport expired. We make the renewal or new application process straightforward for Lincoln's academic and medical professionals.",
  },
  {
    q: "How quickly can travelers in Waverly, Hickman, Seward, or Crete receive an expedited passport?",
    a: "Travelers in these Southeast Nebraska communities have the same access to our expedited services as Lincoln residents. Since we operate remotely, your physical location in Lancaster or Seward County does not affect processing speed. Ship your documents overnight, and we handle the rest. Most clients in the Lincoln metro area receive their passports within 2–9 business days.",
  },
  {
    q: "Can state employees at the Nebraska Capitol get an expedited passport?",
    a: "Yes — Lincoln's state government workforce is well within our service area. Whether you are attending a trade delegation in Asia, an agricultural conference in Europe, or a diplomatic meeting in Latin America, we make the renewal or new application process straightforward. You do not need to drive to Minneapolis for a passport agency appointment. Start online, ship your documents, and we handle the expedited submission.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Lincoln travelers start online and ship their documents via overnight courier. There is a Fast Passport Center office in Lincoln for drop-offs, but most clients never need to visit. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the Lincoln metro area or Southeast Nebraska.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function LincolnFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Lincoln and Southeast Nebraska travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}